import Vue from 'vue'
import Router from 'vue-router'
// 路由懒加载
const Register = () => import('../views/Register.vue')
const Validate = () => import('../views/Validate.vue')
const ResetPassword = () => import('../views/ResetPassword.vue')
const Contact = () => import('../views/contact/Contact.vue')
const ContactSuccess = () => import('../views/contact/ContactSuccess.vue')
const IoaLoginResult = () => import('../views/IoaLoginResult.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/email-login'
    },
    {
      path: '/email-login',
      component: Register
    },
    {
      path: '/activate-account',
      component: Validate
    },
    {
      path: '/reset-password',
      component: ResetPassword
    },
    {
      path: '/contact',
      component: Contact
    },
    {
      path: '/contact-success',
      component: ContactSuccess
    },
    {
      path: '/ioa-login-result',
      component: IoaLoginResult
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js